import {
    Directive,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ModalOpenType } from "@Front-end/ui/models/modal";
import { TranslateService } from "@ngx-translate/core";
import {
    startWith,
    Subscription,
} from "rxjs";
import { environment } from "../../../../environments/environment";
import { LangObj } from "../../../models/lang.model";
import { AppPopupsService } from "../../../store/services/app-popups.service";

@Directive({
    selector: "[lsChooseLangs]",
    standalone: true,
})
export class ChooseLangsDirective implements OnInit, OnDestroy {
    constructor(
        private translateService: TranslateService,
        private appPopupsService: AppPopupsService,
    ) {
    }

    @Input()
    public currentLanguage: LangObj | undefined = undefined;

    @Output()
    public currentLanguageChange: EventEmitter<LangObj> = new EventEmitter<LangObj>();

    public langs: LangObj[] | null = null;
    private langChangeSubscription = new Subscription();

    @HostListener("click", ["$event"])
    public onClick(): void {
        this.openPopupChooseLangsPopup();
    }

    public ngOnInit(): void {
        this.langs = environment.local.map((el: string): LangObj => ({ id: el, value: el }));
        this.langChangeSubscription = this.translateService.onLangChange.pipe(
            startWith({ lang: this.translateService.currentLang }),
        ).subscribe(event => {
            this.currentLanguage = this.langs?.find((language: LangObj) =>
                language.value === event.lang,
            );
            if (this.currentLanguage) {
                this.currentLanguageChange.emit(this.currentLanguage);
            }
        });
    }

    public ngOnDestroy(): void {
        this.langChangeSubscription.unsubscribe();
    }

    private openPopupChooseLangsPopup(): void {
        if (this.currentLanguage && this.langs) {
            this.appPopupsService.fireOpenChooseLangs(this.currentLanguage, this.langs, ModalOpenType.MANUAL);
        }
    }
}
